<template>
  <div class="checkbox-wrapper">
    <div class="checkbox-inner">
      <label class="checkbox">
        <input
          type="checkbox"
          class="checkbox__input"
          tabindex="0"
          @keydown.space="onClick"
        >
        <div
          class="checkbox__custom"
          :class="{'checkbox--active': value}"
          @click="onClick"
        >
          <Transition name="drop">
            <Checkmark
              v-if="value"
              class="checkbox__custom-checkmark"
            />
          </Transition>
        </div>
      </label>

      <div class="checkbox__text" @click="onClick">
        <slot />
      </div>
    </div>

    <Transition name="slide-from-top">
      <span
        v-if="error && errorMsg"
        class="checkbox__error-msg"
      >
        {{ errorMsg }}
        <ErrorIcon/>
      </span>
    </Transition>
  </div>
</template>

<script>
  import Checkmark from '@/assets/img/icons/checkmark.svg?inline'
  import ErrorIcon from '@/assets/img/icons/error.svg?inline'

  export default {
    name: 'BaseCheckbox',
    components: {
      Checkmark,
      ErrorIcon
    },
    props: {
      typeNumber: Boolean,
      value: [Boolean, Number],
      errorMsg: {
        type: String,
        default: ''
      }
    },
    data () {
      return {
        error: null
      }
    },
    watch: {
      errorMsg: {
        handler (msg) {
          this.error = !!msg
        },
        immediate: true
      }
    },
    methods: {
      onClick (event) {
        const target = event.target
        if (target.tagName === 'A') {
          event.preventDefault()
        } else {
          this.error = false
          this.$emit('input', this.typeNumber ? Number(!this.value) : !this.value)
        }
      }
    }

  }
</script>

<style lang="scss">
  $padding-for-error: 28px;

  .checkbox {
    display: inline-block;
    flex-shrink: 0;
    width: 20px;
    height: 20px;

    &-inner {
      display: flex;
      align-items: center;
      width: max-content;
      max-width: 100%;
      cursor: pointer;
    }

    &-wrapper {
      position: relative;
      padding-bottom: $padding-for-error;
    }

    &__custom {
      width: 100%;
      height: 100%;
      cursor: pointer;
      border: 1px solid $c-gray-6;
      border-radius: 4px;
      transition: 0.3s;
      display: flex;
      align-items: center;
      justify-content: center;

      &-checkmark {
        fill: white;
        width: 13px;
        //margin-bottom: 2px;
        //margin-left: 2px;
        //fill: $c-active-light;
      }

      &.checkbox--active {
        background: $c-gray-dark !important;
        fill: white;
      }

      &:before {
        content: '';
        position: absolute;
        width: 26px;
        height: 26px;
        border: 2px solid $c-electric-blue;
        border-radius: 4px;
        opacity: 0;
        visibility: hidden;
        //pointer-events: none;
      }
    }

    &__input {
      position: absolute;
      left: -9999999px;
      width: 0;
      height: 0;
      opacity: 0;

      &:focus-visible {
        & + .checkbox__custom {
          border-color: $c-gray-medium;

          &:before {
            opacity: 1;
            visibility: visible;
          }
        }
      }
    }

    &__text {
      margin-left: 8px;
    }

    &__error-msg {
      display: flex;
      align-items: center;
      justify-content: space-between;
      position: absolute;
      left: 0;
      font-size: 12px;
      color: $c-errorDark;
      height: 20px;
      bottom: 4px;
      width: 100%;

      img,
      svg {
        display: flex;
        min-width: 14px;
        min-height: 15px;
        width: 14px;
        height: 15px;
        object-fit: contain;
      }
    }
  }
</style>
